import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { Helmet } from 'react-helmet';
import { mapStateOnServer } from 'react-helmet/lib/HelmetUtils';
import { Router, StaticRouter } from 'react-router-dom';

import App from './App';

import { history } from '../tracking/tracking';

// defines the order of chunks that show up
const jsChunks = ['manifest', 'lib/vendor', 'store', 'views/index'];
const cssChunks = ['lib/vendor', 'views/index'];

// client render
if (!window.host) {
  ReactDOM.render(
    <Router history={history}>
      <App />
    </Router>,
    document.getElementById('app-root')
  );
}

// "server" render
export default (data) => {
  // collect all the assets to put into the index.html
  const chunksByName = data.webpackStats.toJson().assetsByChunkName;

  const cssFiles = _.map(cssChunks, (c) => {
    const assets = chunksByName[c];
    return Array.isArray(assets) ? _.filter(assets, (f) => f.match(/\.css/))[0] : assets;
  });
  const cssLinks = _.map(cssFiles, (css) => {
    return `<link href="/${css}" rel="stylesheet"></link>`;
  }).join('\n');

  const jsFiles = _.map(jsChunks, (c) => {
    const assets = chunksByName[c];
    return Array.isArray(assets) ? _.filter(assets, (f) => f.match(/\.js/))[0] : assets;
  });
  const jsScripts = _.map(jsFiles, (js) => {
    return `<script type="text/javascript" src="/${js}" ></script>`;
  }).join('\n');

  // render the page based on the path passed in
  const content = ReactDOMServer.renderToString(
    <StaticRouter location={data.path} context={{}}>
      <App host={window.host} />
    </StaticRouter>
  );

  // make sure we sync the helmet
  const helmetProps = Helmet.peek();
  const helmet = mapStateOnServer(helmetProps);

  // todo: use app.html as a template to render
  return `
    <html>
      <head>
        <meta charset="utf-8" />
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        ${helmet.meta.toString()}
        ${helmet.link.toString()}
        ${helmet.title.toString()}
        ${cssLinks}
      </head>
      <body>
        <div id="app-root">${content}</div>
        ${jsScripts}
      </body>
    </html>
  `;
};



// WEBPACK FOOTER //
// ./src/views/index.js